<template>

    <div ref="container" class="d-flex flex-column container">
        <email-verification 
            ref='emailVerification' 
            :item='item' 
            v-on:validated='createItem($event)' />
        
        <loading ref="loading"></loading>
        <header class="text-center">
            <br>
            <!-- <img src="img/icon-signup.svg" class="header-icon"> -->
            <h1 class="h2">{{ $t('translations.sign_up_to')}} {{ tBrand('app_name') }}</h1>
        </header>

        <div v-if='!this.item.practice_code' class="card card-default">
            <p>{{ autobrand('translations.unable_to_register_message')}}</p>
        </div>

        <div v-if='this.item.practice_code' ref="editScroller" class="card-default-mtb-0 flex-grow-1-scroll">

            <local-error v-bind:inline='["email_verification_code", "forenames", "surname", "email", "password", "phone_number", "phone_number_alt", "postcode", "terms"]'></local-error>

            <form>
                <input type="hidden" v-model='item.practice_code'>

                <div class="form-group">
                    <label for="fornames">{{ $t('translations.first_names')}} <span class="required-field">*</span></label>
                    <input class="form-control" type="text" v-model='item.forenames' id="fornames">
                    <inline-error type='forenames'></inline-error>
                </div>

                <div class="form-group">
                    <label for="surname">{{ $t('translations.surname')}} <span class="required-field">*</span></label>
                    <input class="form-control" type="text" v-model='item.surname' id="surname" >
                    <inline-error type='surname'></inline-error>
                </div>

                <div class="form-group">
                    <label for="phone_number">{{ $t('translations.phone_number')}} <span class="required-field">*</span></label>
                    <input class="form-control" type="tel" v-model='item.phone_number' id="phone_number">
                    <inline-error type='phone_number'></inline-error>
                </div>

                <div class="form-group">
                    <label for="alternative_phone_number">{{ $t('translations.alternative_phone_number')}}</label>
                    <input class="form-control" type="tel" v-model='item.phone_number_alt' id="alternative_phone_number">
                    <inline-error type='phone_number_alt'></inline-error>
                </div>

                <div class="form-group">
                    <label for="postcode">{{ $t('translations.postcode')}} <span class="required-field">*</span></label>
                    <input class="form-control text-uppercase" type="text" v-model='item.postcode' id="postcode">
                    <inline-error type='postcode'></inline-error>
                </div>

                <div class="form-group">
                    <label for="email">{{ $t('translations.email')}} <span class="required-field">*</span></label>
                    <input class="form-control" type="email" v-model='item.email' placeholder="name@example.com" id="email">
                    <inline-error type='email'></inline-error>
                </div>

                <password ref='password' v-bind:errors='errors' v-bind:passwordfield.sync='item.password'
                v-bind:email.sync='item.email'
                v-bind:forenames.sync='item.forenames'
                v-bind:surname.sync='item.surname'></password>

                <!-- <div class="form-check">
                    <label>
                        <input type="checkbox" class="form-check-input" name="remember" value="remember" v-model='item.remember'>
                        Remember Me
                    </label>
                </div> -->

                <div class="form-group"  v-if='environment_settings.MIX_ENABLE_LANGUAGE_SELECTION'>
                    <label for="set_default_language">{{ $t('translations.set_default_language')}} <span class="required-field">*</span></label>
                    <select class="form-control custom-select" v-model="item.locale" v-on:change="setLocale" id="set_default_language">
                        <option :key='key' v-for="(lang, key) in $root.lookup.langs" :value="key" placeholder="language">{{ lang }}</option>
                    </select>
                </div>

                <div class="form-check pt-3 pb-2">
                    <input type="checkbox" class="form-check-input" id="terms" v-model='item.terms'>
                    <label class="form-check-label" for="terms"><span>{{ $t('translations.please_accept')}}</span> <a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use')}}</a></label>
                    <inline-error type='terms'></inline-error>
                </div>

            </form>
        </div>
        <footer v-if='this.item.practice_code' class="">
            <button v-on:click.prevent='validateItem($event)' class="btn btn-primary btn-block btn-round" title="Next page">
                {{ $t('translations.next')}}
            </button>
        </footer>

        <div v-if='this.item.practice_code' class="card card-default">
        <strong><a href="https://askmygp.uk/about-us/askmygp-application-privacy-policy/" target="_blank">{{ $t('translations.privacy_policy')}}</a></strong>
        <p style="line-height:1;"><small>{{ $t('translations.privacy_message_overview', {"app_name": this.tBrand("app_name"), "provider_generic_term": this.tBrand("provider_generic_term")}) }}</small></p>
        </div>

        <password-strength-info></password-strength-info>


</div>

</template>

<script>

export default {

    props: {
        'route': {default: '/api/vp1/patients'},
        'event': {},
        'model': {},
        'elementname': {},
        'displayelement': {},
        'type': {},


    },
    data: function() {
        return {
            item: {},
            related_data: {},
            errors: []
        };
    },
    mounted() {
        //window.test123.testabc = 1;
        this.errors = [];
        this.resetItem();
        this.item.practice_code = this.$root.practice_code;
        this.item.locale = this.$root.locale;
        if(this.item.practice_code == null) {
            try {
                if(typeof localStorage === 'object') {
                    this.item.practice_code = localStorage.getItem('practice_code');
                }
            }
            catch(e) {

            }
        }
    },
    methods: {

        resetItem() {
            this.item = {
                id: "",
                forenames: "",
                surname: "",
                email: "",
                dob: "",
                password: "",
                password_confirmation: "",
                gender: "",
                practice_code: "",
                site_id: '',
                locale: this.$root.locale,
            };
            this.errors = [];
        },
        validateItem(event) {
            this.setLoading(true);
            return axios.post('/api/vp1/patients/registerValidate', this.item).then((res) => {
                this.errors = [];
                this.setLoading(false);
                this.$refs.emailVerification.getEmailVerificationCode();
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "update");
                this.scrollFirstError();
            });
        },
        createItem(event) {  
            this.setLoading(true);
            this.item.provider_id = window.provider_id;
            return axios.post(this.route + '/register', this.item).then((res) => {
                return axios.post('/ajaxlogin', {"email": this.item.email, "password": this.item.password}).then((res) => {
                    //this.addNotification({type: "success", content: 'Logged in successfully'});

                    window.api_token = res.data.api_token;
                    this.$root.api_token = window.api_token;

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

                    if(!this.$route.params.next) {
                        this.$route.params.next = "Profile";
                    }

                    return this.$root.loadCore(true, {name: this.$route.params.next});
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                    this.scrollFirstError();
                });
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
                this.scrollFirstError();
            });
        },
        setLocale() {
            Vue.nextTick(() => {
                this.$root.setLocale(this.item.locale);
            });
        },
        // __testing_autofillTestRegistration() {
        //     var password = new Array(12).fill().map(() => String.fromCharCode(Math.random()*86+40)).join("");
        //     this.item = {
        //         "forenames":"TEST",
        //         "surname":"TEST",
        //         "email":"adam-loadtest-RAND@redpixelyellowpixel.com",
        //         //"dob":this.moment(new Date(+(new Date()) - Math.floor(Math.random()*10000000000))).format('YYYY-MM-DD'),
        //         "password":password,
        //         "password_confirmation":password,
        //         "phone_number":"07890123456",
        //         "postcode":"A11AA",
        //         "practice_code":"X99998",
        //         "site_id":"",
        //         "locale":"en",
        //         "terms":1
        //     }
        // }


    }
}

</script>
